import React from 'react';
import { formatCurrency } from 'utils';
import { Typography } from '@mui/material';

import { QuoteChargeCalcResult } from '../../../../types';

export const EquipmentChargeGrandTotalCell = ({ priceCalc }: { priceCalc: QuoteChargeCalcResult }) => {
  return <Typography>Total: {formatCurrency(priceCalc.totals.grandTotal ?? null, true)}</Typography>;
};
